// extracted by mini-css-extract-plugin
export default {"m":"_70fecdaeed","title":"_9084513783","feedback_inner_title":"_25d58f4302","textarea":"_4d1e730a7c","radio":"_14c47d76ac","text":"_75a4326245"};